import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {API_BASE_URL} from '../../utils/paths';

export const handleRequestReset = createAsyncThunk(
  'password/requestReset',
  async ({ email }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue({ message: error.message });
    }
  }
);

export const handlePasswordReset = createAsyncThunk(
  'password/confirmReset',
  async (resetData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(resetData),
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue({ message: error.message });
    }
  }
);

const passwordResetSlice = createSlice({
  name: 'passwordReset',
  initialState: {
    loading: false,
    error: null,
    errors: {},
    success: null,
    requestSent: false,
    resetComplete: false,
  },
  reducers: {
    clearMessages: (state) => {
      state.error = null;
      state.success = null;
    },
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
      state.requestSent = false;
      state.resetComplete = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle request reset
      .addCase(handleRequestReset.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.errors = {};
        state.success = null;
      })
      .addCase(handleRequestReset.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.errors = {};
        state.requestSent = true;
        state.success = 'Password reset link sent to your email! Check your inbox.';
      })
      .addCase(handleRequestReset.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to send reset link';
        state.errors = action.payload?.errors || {};
      })
      // Handle password reset
      .addCase(handlePasswordReset.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.errors = {};
        state.success = null;
      })
      .addCase(handlePasswordReset.fulfilled, (state, action) => {
        state.loading = false;
        state.resetComplete = true;
        state.error = null;
        state.errors = {};
        state.success = 'Password reset successfully! You can now log in with your new password.';
      })
      .addCase(handlePasswordReset.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to reset password';
        state.errors = action.payload?.errors || {};
      });
  },
});

export const { clearMessages, resetState } = passwordResetSlice.actions;
export default passwordResetSlice.reducer;